import { useEbbnenContext } from "@solidwhite/ebbnen";
import { useTranslation } from "react-i18next";

const IndustryApplication = ({ application, ...props }) => {
  const { locationHook } = useEbbnenContext();
  const [location, setLocation] = locationHook();

  const { t } = useTranslation();

  const handleClick = (e) => {
    e.stopPropagation();

    // setLocation(`/heating/${application.href}`);
    setLocation(`/${application.href}`);
  };

  return (
    <span
      style={{
        margin: "0 1vw",
        pointerEvents: "auto",
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        flexDirection: "column",
        color: "white",
        fontSize: "0.75vw",
      }}
      onClick={handleClick}
    >
      <div style={{ paddingBottom: "0.5vw" }}>{t(application.textId)}</div>
      <img
        style={{
          width: "3vw",
          height: "3vw",
          cursor: "pointer",
        }}
        src={application.image}
        alt={application.name}
      />
    </span>
  );
};

export default IndustryApplication;
